export default {"src":"/_next/static/media/assistant-cleaner-with-small-green-text-box.c921ec15.svg","height":336,"width":367};